export default __webpack_public_path__ + "static/media/BulbGlow.ffb0ac9b.svg";